import { SectionContainerTypes } from '@genial/components';
import { FunctionComponent } from 'react';

import { TableHeadItemRecurse } from '../../../../components/TableHead';

import { InvestmentStrategyListDiversifier } from './components/Diversifier/InvestmentStrategyListDiversifier';
import { InvestmentStrategyListPositive } from './components/Positive/InvestmentStrategyListPositive';
import { InvestmentStrategyListTypes } from './types';

export const moduleName = 'ESTRATÉGIA DE INVESTIMENTO';

export const investmentStrategyTypesNames = {
  positive: 'POSITIVADOR',
  diversifier: 'DIVERSIFICADOR',
};

export const sectionContainerOptions: SectionContainerTypes.FilterOption[] = [
  { label: investmentStrategyTypesNames.positive, value: 'positive' },
  { label: investmentStrategyTypesNames.diversifier, value: 'diversifier' },
];

export type InvestmentStrategyType = keyof typeof investmentStrategyTypesNames;

export const investmentStrategyListTypes: Record<
  InvestmentStrategyType,
  FunctionComponent<InvestmentStrategyListTypes.Props>
> = {
  positive: InvestmentStrategyListPositive,
  diversifier: InvestmentStrategyListDiversifier,
};

export const tableHeadPositive: TableHeadItemRecurse[] = [
  { title: 'Data', flex: 1 },
  { title: 'Cliente', flex: 3 },
  { title: 'Conta de custódia', flex: 2 },
  { title: 'Conta sinacor', flex: 2 },
  { title: 'CPF/CNPJ', flex: 2 },
  { title: 'Nome do assessor', flex: 3 },
  { title: 'Filial', flex: 3 },

  { title: 'Produto', flex: 1 },
  { title: 'Classe', flex: 1 },
  { title: 'Qtd.', flex: 1 },
  { title: 'Valor PU', flex: 1 },
  { title: 'Data PU', flex: 1 },
  { title: 'Valor produto', flex: 1 },
];

export const tableHeadDiversifier: TableHeadItemRecurse[] = [
  { title: 'Data', flex: 1 },
  { title: 'Cliente', flex: 3 },
  { title: 'Conta de custódia', flex: 2 },
  { title: 'Conta sinacor', flex: 2 },
  { title: 'Total PL', flex: 1 },
  { title: 'Estado', flex: 1 },

  { title: 'Nome do assessor', flex: 2 },
  { title: 'Filial', flex: 2 },
  { title: 'Suitability', flex: 1 },
  { title: 'Telefone', flex: 1 },
  { title: 'Situação', flex: 1 },
];
